import React, { useContext } from 'react';
import AuthContext from '../../../contexts/auth';
import PageContainer from '../../../components/layout/PageContainer';
import { translate } from '../../../utils/Common';
import AdminHome from './AdminStats';
import UserHome from './UserStats';
import CounterHome from './CounterHome';

// vista de home insights
const Home = () => {
  const UserContext = useContext(AuthContext);

  const getName = () => {
    const simpleName = UserContext.user?.NombreSimple || '';
    const parts = simpleName.trim().split(' ');
    return parts[0] || simpleName || 'Usuario';
  };

  const greetings = () => {
    const hour = new Date().getHours();
    if (hour >= 0 && hour < 12) {
      return translate('dashboard.home.greeting.morning');
    }
    if (hour >= 12 && hour < 19) {
      return translate('dashboard.home.greeting.afternoon');
    }
    return translate('dashboard.home.greeting.evening');
  };

  const renderDashboardContent = () => {
    if (UserContext.user?.IsAdmin) {
      return <AdminHome />;
    }
    if (UserContext.user?.IdTipoUsuario === 6) {
      return <CounterHome />;
    }
    return <UserHome />;
  };

  return (
    <PageContainer maxWidth="xl" padding="md" className="flex flex-col gap-4">
      {/* Compact on purpose: the greeting is courtesy, the data is the page.
          A full PageHeader here ate ~120px before the first figure. */}
      <div>
        <h1 className="m-0 text-xl font-semibold tracking-tight text-foreground">
          {greetings()} {getName()}
        </h1>
        <p className="m-0 mt-0.5 text-[13px] text-muted-foreground">
          {translate('dashboard.home.welcome')}{' '}
          <span className="font-medium text-foreground">{translate('dashboard.home.team')}</span>
        </p>
      </div>

      <div className="w-full">{renderDashboardContent()}</div>
    </PageContainer>
  );
};

export default Home;